/* eslint-disable react/jsx-props-no-spreading */
import Intercom from "./IntercomSource";
import config from "../config";

const IntercomWidget = () => {
	return (
		<>
			{process.env.ENVIRONMENT === "production" && (
				<Intercom appID={config.intercom} />
			)}
		</>
	);
};

export default IntercomWidget;
